import type {
  OperatorFormValues,
  VenueFormValues,
} from '@/features/metadata-library/types/libraryFormValues';
import { createFieldMap } from '@tanstack/react-form';

export const VENUE_EMPTY_VALUES: VenueFormValues = {
  businessName: '',
  businessId: '',
  environmentL1: '',
  environmentL2: '',
  latitude: '',
  longitude: '',
  address: '',
  addressCountry: '',
  addressLine1: '',
  subLocality: '',
  locality: '',
  adminArea: '',
  employees: '',
};

export const OPERATOR_EMPTY_VALUES: OperatorFormValues = {
  vendor: '',
  vendorOperatorId: '',
  operatorName: '',
  operatorJob: '',
  ageRange: '',
  gender: '',
  handedness: '',
  consent: '',
  roleExperienceMonths: '',
  taskExperienceMonths: '',
  handSizeCm: {
    wristCenterToMiddleFingertipCm: '',
    thumbToPinkySpreadCm: '',
    middleFingertipToKnuckleCm: '',
  },
};

/**
 * Where the operator field group's fields live when they sit at the form root,
 * for `<OperatorRecordFields fields={OPERATOR_FIELD_MAP} />`. A form that nests
 * them under a key passes that path instead (e.g. `fields="operator"`).
 */
export const OPERATOR_FIELD_MAP = createFieldMap(OPERATOR_EMPTY_VALUES);
